import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import helpersTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import validateFormAddAskCheckOut from "../../../../validtions/forms/marketer/add-checkout";

function Add({ charge }) {
  const [amount, setAmount] = useState(0);
  const [message, setMessage] = useState();
  const history = useHistory();
  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const inputBankCardNumberPartBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
    const number = e.target.value;
    if (number.length > 3) {
      e.preventDefault();
      return;
    }
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".card-body");
    element.scrollIntoView();
  };

  const sendForm = async () => {
    const dataForm = getDataForm();
    const resultValidateFormAddAskCheckOut =
      validateFormAddAskCheckOut(dataForm);
    if (resultValidateFormAddAskCheckOut != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: resultValidateFormAddAskCheckOut,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultAddAskTransaction = await sendRequestAddAskTransaction(
      dataForm
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultAddAskTransaction) {
      return;
    }

    history.push("/marketer/all-ask-checkout");
  };

  const sendRequestAddAskTransaction = async (dataForm) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/marketer/ask-checkout",
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return false;
    }
  };

  const getBankAccountNumber = () => {
    return (
      document.querySelector("#card-number-1").value +
      "-" +
      document.querySelector("#card-number-2").value +
      "-" +
      document.querySelector("#card-number-3").value +
      "-" +
      document.querySelector("#card-number-4").value
    );
  };

  const getDataForm = () => {
    return {
      wallet: charge,
      price: amount + "",
      bank_name: document.querySelector("#bank-name").value,
      owner_account_name: document.querySelector("#owner-account").value,
      account_number: document.querySelector("#bank-account-number").value,
      account_cart_number: getBankAccountNumber(),
      account_shaba_number: document.querySelector("#shaba-number").value,
    };
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن درخواست تسویه حساب" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <>
                <div className="alert alert-warning">
                  <p className="text-justify">
                    <i className="fa fa-info pl-2"></i>
                    توجه داشته باشید :{" "}
                  </p>
                  <ul className="pr-3">
                    <li>
                      <p className="text-justify">
                        حداقل مبلغ درخواستی برای انتقال وجه{" "}
                        <span className="number-finance">
                          {helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(
                              process.env
                                .REACT_APP_AT_LEAST_AMOUNT_ASK_CHECK_OUT_MARKETER
                            )
                          )}{" "}
                        </span>
                        هزار تومان میباشد.
                      </p>
                    </li>
                  </ul>
                </div>

                {messageTag}

                <p>
                  <span>موجودی شما : </span>
                  <span className="number-finance">
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(charge)
                    )}
                  </span>
                  <span className="pr-2">تومان</span>
                </p>

                <div>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      sendForm();
                    }}
                  >
                    <div className="form-group">
                      <label>مبلغ (تومان)</label>
                      <input
                        tabindex="1"
                        type="text"
                        id="price"
                        className="form-control number-finance"
                        value={helpersNumbers.toPersianNum(
                          helpersNumbers.toFormatFinanceNumber(amount)
                        )}
                        onChange={inputAmountChangeHandler}
                        onBeforeInput={inputAmountBeforeInputHandler}
                        dir="ltr"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>نام بانک </label>
                      <input
                        tabindex="2"
                        type="text"
                        className="form-control"
                        id="bank-name"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>نام مالک حساب</label>
                      <input
                        tabindex="3"
                        type="text"
                        className="form-control"
                        id="owner-account"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>شماره حساب بانکی</label>
                      <input
                        tabindex="4"
                        dir="ltr"
                        type="text"
                        id="bank-account-number"
                        onBeforeInput={inputAmountBeforeInputHandler}
                        class="form-control number-finance"
                        required
                      />
                    </div>

                    <div className="form-group">
                      <label>شماره کارت بانکی </label>
                      <div className="ltr d-flex">
                        <div className="pr-2">
                          <input
                            tabindex="5"
                            dir="ltr"
                            type="text"
                            id="card-number-1"
                            className="form-control number-finance text-center"
                            onBeforeInput={
                              inputBankCardNumberPartBeforeInputHandler
                            }
                            required
                          />
                        </div>
                        <div className="pr-2">
                          <input
                            tabindex="6"
                            dir="ltr"
                            type="text"
                            id="card-number-2"
                            className="form-control number-finance text-center"
                            onBeforeInput={
                              inputBankCardNumberPartBeforeInputHandler
                            }
                            required
                          />
                        </div>
                        <div className="pr-2">
                          <input
                            tabindex="7"
                            dir="ltr"
                            type="text"
                            id="card-number-3"
                            className="form-control number-finance text-center"
                            onBeforeInput={
                              inputBankCardNumberPartBeforeInputHandler
                            }
                            required
                          />
                        </div>
                        <div>
                          <input
                            tabindex="8"
                            dir="ltr"
                            type="text"
                            id="card-number-4"
                            className="form-control number-finance text-center"
                            onBeforeInput={
                              inputBankCardNumberPartBeforeInputHandler
                            }
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label>شماره شبا </label>
                      <div class="input-group">
                        <input
                          tabindex="9"
                          type="text"
                          onBeforeInput={inputAmountBeforeInputHandler}
                          class="form-control number-finance"
                          dir="ltr"
                          id="shaba-number"
                          required
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">IR</span>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <button className="btn btn-success">ارسال درخواست</button>
                    </div>
                  </form>
                </div>
              </>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    charge: state.main.charge,
  };
};
export default connect(mapStateToProps, null)(Add);
